export default "__VITE_ASSET__BtmT4HCs__"